import Form from './PhishingForm'
import schema from './schema'

export { Form, schema }

export default Form
